<script setup lang="ts">
const props = defineProps<{
  collapsed: boolean | undefined
}>()
// Props: collapsed
</script>

<template>
  <!-- :class was previously `{ '': collapsed, '': !collapsed }` — both
       keys were empty strings, which esbuild flagged as a duplicate-key
       warning ("Duplicate key '' in object literal") and which applied
       no classes either way. Removed entirely; the inner border / img
       / text divs handle the collapsed-vs-expanded visuals themselves. -->
  <!-- Left-aligned + items-center so the mark stays put as the sidebar
       resizes (the old `justify-center` re-centered the whole lockup,
       making it drift when the panel widened). The mark is a fixed
       square (shrink-0) that fills its box; the wordmark wraps cleanly
       beside it. -->
  <div class="flex items-center select-none" :class="{ 'justify-center': collapsed }">
    <!-- Fixed 40px square (size-10) in BOTH states so it matches the advisor
         avatar + collapsed household square exactly. When collapsed the parent
         centers it (justify-center above); when expanded the wordmark sits to
         its right. -->
    <div class="shrink-0 size-10 flex items-center justify-center border border-[#0A502433] rounded bg-white overflow-hidden">
      <img src="~/assets/img/Azzad Asset Logo Symbol Square.png" class="block w-full h-full object-contain p-0.5 rounded-xs" alt="Azzad Asset Logo" />
    </div>
    <div class="ml-2 flex flex-col min-w-0" v-if="!collapsed">
      <h1 class="text-xs font-bold font-playfair text-black leading-tight">
        Azzad Asset Management
      </h1>
      <p class="text-[0.6rem] font-light text-[#070707]">
        Version 2.01
      </p>
    </div>
  </div>
</template>

<style scoped>

</style>
